import { PropsWithChildren, ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Image, View, StyleSheet } from 'react-native';
import Images from '_images';
import { WH, WW } from '_utils';
import { screenMargin, smallestFontSize, smallestMargin, titleFontSize } from '_utils/sizes';
import { useThemeContext } from '_utils/themeContext';
import {
    CARD_BUTTON_ICON_SIZE,
    CARD_BUTTON_ICON_MARGIN_TOP,
    CARD_BUTTON_ICON_MARGIN_BOTTOM,
    CARD_BUTTON_LABEL_MARGIN_BOTTOM,
    CARD_BUTTON_LABEL_SIZE,
} from 'Components/CardButton';
import HeimeText from 'Components/HeimeText';
import TouchableHeime from 'Components/TouchableHeime';

type ImageCardButtonProps = {
    type: 'parking';
    communityLabel?: boolean;
    onPress: () => void;
};

const ImageCardButton = ({ type, communityLabel, onPress }: ImageCardButtonProps): ReactElement => {
    const { theme } = useThemeContext();
    const { t } = useTranslation();

    return (
        <TouchableHeime
            onPress={onPress}
            style={{
                borderRadius: 20,
                width: WW * 0.4,
                minHeight:
                    CARD_BUTTON_ICON_SIZE +
                    CARD_BUTTON_ICON_MARGIN_TOP +
                    CARD_BUTTON_ICON_MARGIN_BOTTOM +
                    CARD_BUTTON_LABEL_MARGIN_BOTTOM +
                    CARD_BUTTON_LABEL_SIZE,
                backgroundColor: theme.mainBackground,
                overflow: 'hidden',
                marginBottom: WH * 0.03,
            }}
        >
            <Image
                source={Images[type]}
                style={{ width: '100%', height: '100%', position: 'absolute' }}
                resizeMode="cover"
            />
            <View
                style={{
                    ...StyleSheet.absoluteFillObject,
                    backgroundColor: 'rgba(0,0,0,0.45)',
                }}
            />
            <View
                style={{
                    flex: 1,
                    justifyContent: 'center',
                    alignItems: 'center',
                    paddingVertical: screenMargin,
                    gap: smallestMargin,
                }}
            >
                {communityLabel ? <CommunityBadge>{t('services:community')}</CommunityBadge> : null}
                <View>
                    <HeimeText
                        style={{
                            color: theme.white,
                            fontWeight: 'bold',
                            textShadowColor: '#000',
                            textShadowOffset: { width: 0, height: 2 },
                            textShadowRadius: 6,
                            fontSize: titleFontSize,
                            textAlign: 'center',
                        }}
                    >
                        {t(`services:${type}`)}
                    </HeimeText>
                </View>
            </View>
        </TouchableHeime>
    );
};

const CommunityBadge = ({ children }: PropsWithChildren<unknown>) => {
    const { theme } = useThemeContext();
    return (
        <View
            style={{
                backgroundColor: theme.mainBackground,
                borderRadius: 24,
                paddingHorizontal: smallestMargin,
                paddingVertical: 4,
                alignSelf: 'center',
                shadowColor: '#000',
                shadowOffset: { width: 0, height: 2 },
                shadowOpacity: 0.15,
                shadowRadius: 4,
            }}
        >
            <HeimeText style={{ color: theme.main, fontWeight: 'bold', fontSize: smallestFontSize }}>
                {children}
            </HeimeText>
        </View>
    );
};

export default ImageCardButton;
